// store/modules/cart.js
import { fetchCartSummary } from "@/services/api/cartApi";

const toSummary = (p) => ({
  itemCount: Number(p?.itemCount ?? 0),
  quantityTotal: Number(p?.quantityTotal ?? 0),
  revision: Number(p?.revision ?? 0),
});

export default {
  namespaced: true,
  state: () => ({
    summary: { itemCount: 0, quantityTotal: 0, revision: 0 },
    lastFetchedAt: 0,
    ttlMs: 60_000, // revalidar no máx. 1x por minuto
    loading: false,
  }),
  getters: {
    isStale: (s) => Date.now() - s.lastFetchedAt > s.ttlMs,
    quantityTotal: (s) => s.summary.quantityTotal,
  },
  mutations: {
    SET_SUMMARY(state, payload) {
      state.summary = toSummary(payload);
      state.lastFetchedAt = Date.now();
    },
    SET_LOADING(state, v) {
      state.loading = !!v;
    },
    RESET_CART(state) {
      state.summary = { itemCount: 0, quantityTotal: 0, revision: 0 };
      state.lastFetchedAt = 0;
    },
  },
  actions: {
    async fetchSummary({ state, commit }) {
      commit("SET_LOADING", true);
      try {
        const res = await fetchCartSummary({
          ifNoneMatch: state.summary.revision,
        });
        if (res) commit("SET_SUMMARY", res); // 200 → atualiza; 304 → res==null, mantém
        return state.summary;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async fetchIfStale({ getters, dispatch }) {
      if (!getters.isStale) return;
      await dispatch("fetchSummary");
    },
    bumpFromMutation({ commit }, newSummary) {
      commit("SET_SUMMARY", newSummary);
    },
    RESET_CART({ commit }) {
      commit("RESET_CART");
    },
  },
};
